import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'

import { encodeAndCopyToClipboard } from '@/utils/clipboard'

export const copySelectedStickyNote = () => (dispatch, getState) => {
  const {
    canvas: {
      stickyNote: { selectedStickyNote },
    },
  } = getState()

  if (!selectedStickyNote) {
    return
  }

  const stickyNote = migrationProjectSelector.getProjectStickyNoteById(
    selectedStickyNote
  )(getState())

  if (!stickyNote) {
    return
  }

  const payload = {
    id: stickyNote.id,
    type: 'note',
    options: {
      content: stickyNote.content,
      color: stickyNote.color,
      offset: stickyNote.offset,
      size: stickyNote.size,
      textSize: stickyNote.textSize,
    },
  }

  encodeAndCopyToClipboard(payload, 'stickyNote')
}
